import { PageMeta } from '../components/seo/PageMeta'
import { pageMeta } from '../lib/seo'

export default function SmsMarketingTerms() {
  return (
    <>
      <PageMeta
        title={pageMeta.smsMarketingTerms.title}
        description={pageMeta.smsMarketingTerms.description}
        canonical={pageMeta.smsMarketingTerms.canonical}
      />
      <main className="min-h-screen pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="font-body text-cream-dim text-sm mb-8">Last updated: June 15, 2026.</p>
          <h1 className="font-display font-bold text-2xl uppercase text-white mb-8">
            NextTech Consultants Marketing SMS Program Terms
          </h1>
          <div className="font-body text-cream-dim space-y-6 prose prose-invert max-w-none">
            <p>
              <strong className="text-white">1. Program Description and Use Cases.</strong> By opting in, you agree to receive marketing and promotional SMS messages from NextTech Consultants. Messages may include special offers, service promotions, event announcements, reminders, and company updates.
            </p>

            <p>
              <strong className="text-white">2. Message Frequency.</strong> Message frequency varies based on your engagement and campaign activity.
            </p>

            <p>
              <strong className="text-white">3. Opt-Out Instructions.</strong> You can cancel SMS at any time by texting <strong className="text-white">STOP</strong>. After you text STOP, we will send a confirmation message and you will no longer receive marketing SMS from us unless you opt in again.
            </p>

            <p>
              <strong className="text-white">4. Help Instructions.</strong> If you need assistance, text <strong className="text-white">HELP</strong> or contact us at{' '}
              <a href="mailto:info@nexttechconsultants.com" className="text-accent hover:underline">info@nexttechconsultants.com</a>{' '}
              or 971.238.4801.
            </p>

            <p>
              <strong className="text-white">5. Fees.</strong> Message and data rates may apply for messages sent to you from us and to us from you. Contact your wireless carrier for details about your messaging plan.
            </p>

            <p>
              <strong className="text-white">6. Carrier Liability.</strong> Carriers are not liable for delayed or undelivered messages.
            </p>

            <p>
              <strong className="text-white">7. Age Requirement.</strong> You must be 18 years of age or older, or have permission from a parent or legal guardian, to opt in to this marketing SMS program.
            </p>

            <p>
              <strong className="text-white">8. Privacy Policy.</strong> Please review our{' '}
              <a href="https://nexttechconsultants.com/privacy" className="text-accent hover:underline">Privacy Policy</a>{' '}
              for details on how your information is collected and used.
            </p>
          </div>
        </div>
      </main>
    </>
  )
}

export { SmsMarketingTerms as Component }
